const jsonHeaders = () => ({
    'Content-Type': 'application/json',
    'X-CSRFToken': window.csrf_token,
});

export const getBrandProfile = (projectId) =>
    fetch(`/api/v1/tracking-projects/${projectId}/profile/`, {
        headers: jsonHeaders(),
    });

// The backend cannot profile a brand without a market, and answers with this code when neither
// the request nor the project carries a country/language.
export const MISSING_MARKET_CODE = 'project_country_language_empty';

// The AI call runs inline on the server, so this request stays open for a while.
export const generateBrandProfile = (projectId, force = false) =>
    fetch(`/api/v1/tracking-projects/${projectId}/profile/${force ? '?force=true' : ''}`, {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({}),
    });

export const updateBrandProfile = (projectId, data) =>
    fetch(`/api/v1/tracking-projects/${projectId}/profile/`, {
        method: 'PATCH',
        headers: jsonHeaders(),
        body: JSON.stringify(data),
    });

export const getProjectTopics = (projectId) =>
    fetch(`/api/v1/generated-topics/?project_id=${projectId}`, {
        headers: jsonHeaders(),
    });

export const deleteBrandProfile = (projectId) =>
    fetch(`/api/v1/tracking-projects/${projectId}/profile/`, {
        method: 'DELETE',
        headers: jsonHeaders(),
    });

// Prompt generation is shared with the prompt generator: the settings page only ever kicks it
// off for a single topic, but it is the same endpoint, payload and polling contract -- and it
// spends from the same pool of credits, which the topics card reports.
export { getPromptCredits } from '../promptGenerator/query';
export { generatePrompts } from '../promptGenerator/components/ExistingTopics/query';
export { getPromptGenerationApi } from '../prompt/components/Topics/query';

// Bulk frequency change is the same endpoint the prompt manager uses; this card only ever sends it
// a `project` instead of a list of ids.
export { bulkUpdateFrequency } from '../PromptManager/query';
